import {useState} from 'react';
import { Card, CardContent, Grid, CardActionArea, Box, Button} from '@mui/material';
import RegistrationForm from '../charging-stations/RegistrationForm';
import Breadcrumb from "../../../../UI/breadcrumb/breadcrumb";
import GlobalSnackBar from 'UI/snackbar/GlobalSnackBar';
import EVchargerForm from './EVchargerForm';
import { earnWithUs } from '../cardData';
import { v4 as uuidv4 } from 'uuid';
import "../../../../scss/common.scss";
import { useNavigate } from 'react-router';


const EarnWithUs = () => {
    const[registerationForm,setRegistrationForm]=useState('earnWithUs');
    const [toggleSnackbar, setToggleSnackbar] = useState({ message: '', isToggle: false, mode: '' });
    const tempArray = [
        { name: "Services " },
        { name: "Dashboard ", onClickNavigateTo: "/" },
        { name: "/" },
        { name: " Charging Station", onClickNavigateTo: "/personal-services", color: '#00BCD4' },
        { name: " / Earn with us" },
      ];
      const navigate = useNavigate()
    return (
        <>
            <Box sx={{ position: 'relative' }}>
                <Breadcrumb breadCrumbData={tempArray} />
                {toggleSnackbar.isToggle && <GlobalSnackBar isOpenSnack={toggleSnackbar}
                setIsOpenSnack={setToggleSnackbar} />}
            </Box>
            <Grid container spacing={4} className="service-select-user">
                {registerationForm==="earnWithUs" && (earnWithUs?.map((card: any, index: number) =>
                    <Grid item lg={3} md={4} sm={6} xs={12} key={uuidv4()}>
                            <Card sx={{ boxShadow:'none',borderRadius:'6px', 
                             "&:hover": {transition: "0.3s",outline: "1.5px solid #ffc816",boxShadow: "0px 1px 1px -1px"},
                        }} className="cursor-pointer card-hover-color" onClick={()=> setRegistrationForm(card.link)}>
                               <CardActionArea sx ={{pt:2, pb:1}} >
                                    <CardContent sx={{ display: "block", textAlign: "center", pt: 4 }}>
                                        <img className = 'imgcolor'  src={card.image} alt="cards" />
                                        <p className='fs-18 fw-500'>{card.title}</p>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                    </Grid>
                ))}
            </Grid>
            <Button onClick={()=>navigate('/personal-services')} sx={{ color: "black",mt:'20px' }} >
                Back
            </Button>
            {registerationForm === "charginStation" && <RegistrationForm back={()=>setRegistrationForm('earnWithUs')} setToggleSnackbar={setToggleSnackbar}/>}
            {registerationForm === "rentYourSpace" && <EVchargerForm back={()=>setRegistrationForm('earnWithUs')}/>}
        </>
    )
}

export default EarnWithUs;
